import { Pipe, PipeTransform } from '@angular/core';

import { TimeSlot } from '../store/entities';

@Pipe({
  name: 'hourstamp'
})
export class HourstampPipe implements PipeTransform {

  transform(timeSlot: TimeSlot, property: string, format: string = 'hh:mm'): any {
    if (!timeSlot || !timeSlot[property] || !timeSlot[property].length) {
      return '00:00';
    }
    return this.formatTime(timeSlot[property][0]) + (format === 'hh:mm' ? ':' + this.formatTime(timeSlot[property][1]) : '');
  }

  private formatTime(time: number): string {
    return time.toString().padStart(2, '0');
  }

}
